export default __webpack_public_path__ + "static/media/MOTION-SICKNESS.618bc3d8.png";